interface PulseInputProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

const FormInput: React.FC<PulseInputProps> = ({
  id,
  value,
  onChange,
  placeholder,
}) => {
  return (
    <div className="pulse-search-input pulse-justify-flex-start">
      <input
        id={id}
        name={id}
        className="pulse-debounced-input pulse-justify-flex-start pulse-br-sm pulse-bg-color--background-800 pulse-color--background-50 pulse-typography-body-2"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
};

export default FormInput;
